<template>
  <div class="ClaimSuccess">
    <div class="main">
        <img class="logo" src="../images/logo_za.png" alt="众安保险">
        <div class="claim_success">
            <div class="icon"></div>
            <p class="result">索赔登记成功！</p> 
            <p class="tips">请尽快用电脑登陆 <span>{{`https://a.lianwifi.com/insurance/static/pc/store.html`}}</span> ，下载填写交易补偿申请表，并准备相关索赔资料寄送指定地址，方便理赔。</p>
            
            <p class="view"><router-link to="/new/docs">查看索赔所需资料</router-link><router-link to="/new/claimFlow">了解索赔流程</router-link> </p>
        </div>
        
    </div>
    <div class="bottom_bg"></div>
  </div>
</template>

<script>
export default {
  name: 'newclaimSuccess',
  data() {
    return {
      pageUrl: '',
    }
  },
  mounted(){   
    // Utils.Tracker.send({
    //     data: {
    //         f: 'wifiins',
    //         b: 'ins_spsuc'
    //     }
    // });
  }
}
</script>

<style scoped>
.main{margin-top: 15px;text-align: center}
.logo{width: 60%;}
.main .claim_success{margin-top: 40px; width: 88%;padding: 0 6%;}
.main .claim_success .icon{
    width: 50px;
    height: 60px;
    margin: 0 auto;
    background-image: url(../images/success.png);
    background-repeat: no-repeat;
    -webkit-background-size: 100%;
        background-size: 100%;    
}
.main .result,.main .contact,.main .tips{text-align: center;width: 100%;padding: 0;margin-top: 16px;margin-bottom: 16px;}
.main .result{ font-size: 24px; color: #333333;}
.main .contact{font-size: 13px;color: #333333;font-weight: bold; }
.main .tips{font-size: 13px;color: #666666;font-weight: bold;line-height: 1.8;}
.main .tips span{color: #0285f0;}
.main a{text-decoration: none}
.main .view a{margin-right: 10px;text-decoration:underline;}
</style>



// WEBPACK FOOTER //
// claimSuccess.vue?7e644828